module.exports = __webpack_public_path__ + "img/04_null.54c239bf.png";